export const WEBHOOK_SET_INITIAL_STATE = 'WEBHOOK_SET_INITIAL_STATE';
export const WEBHOOK_FIND_ALL = 'WEBHOOK_FIND_ALL';
export const WEBHOOK_VIEW = 'WEBHOOK_VIEW';
